import type { MaybeRef } from '@vueuse/core'
import type { Elemental, ElementalTypeEnum } from '../types/elemental'
import { PriceType } from '../types/api'
const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
export function getInitialFormData(
  initial: Partial<Elemental>,
  elementalType: ElementalTypeEnum,
  elemetal?: MaybeRef<Elemental | null | undefined>,
) {
  const elementalUnref = elemetal ? unref(elemetal) ?? null : null

  if (elementalUnref?.id) {
    const data = {
      ...initial,
      ...elementalUnref,
      title: elementalUnref?.title ?? '',
      priceOriginal: (elementalUnref?.priceOriginal || 0) / 100,
      template: elementalUnref?.template || '',
      tutorialStep: elementalUnref?.tutorialStep || [],
      isTutorialHidden: elementalUnref?.isTutorialHidden || true,
      priceTypeId:
        elementalUnref?.priceTypeId === 2
          ? PriceType.fairPrice
          : PriceType.fixed,
      price: (elementalUnref?.price || 0) / 100,
      typeId: elementalUnref?.typeId || 1,
      description: elementalUnref?.description || '',
      isFixedPrice: elementalUnref?.priceTypeId === PriceType.fixed,
      attachmentsVisibility: elementalUnref?.attachmentsVisibility || 'NONE',
      elementalsVisibility: elementalUnref?.elementalsVisibility || 'NONE',
      images: {
        cover: [...(elementalUnref?.images?.cover || [])],
        output: [...(elementalUnref?.images?.output || [])],
      },
      coverImages: [],
      itemIds: elementalUnref?.itemIds || [],
      listIds: elementalUnref?.listIds || [],
      attachments: [],
      outputImages: [],
      maxCoverImages: 0,
      maxOutputImages: 0,
      command: elementalUnref?.command?.trigger || '',
      metadata: elementalUnref.metadata
        ? typeof elementalUnref.metadata === 'string'
          ? JSON.parse(elementalUnref.metadata)
          : elementalUnref.metadata
        : {},
    }
    return data
  }
  return {
    ...initial,
    title: `Untitled ${capitalize(getElementalTypeRoute(elementalType))}`,
  }
}
